module.exports = __webpack_public_path__ + "img/First GPG.e02c7780.png";